export const BUBBLE = 0;
export const QUICK = 1;
export const MERGE = 2;
export const INSERTION = 3;